"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tickers = exports.Ticker = void 0;
class Ticker {
    constructor(ticker) {
        this.marketId = 0;
        this.symbol = '';
        this.lastPrice = 0;
        this.delta24h = 0;
        this.high24h = 0;
        this.low24h = 0;
        this.volume24h = 0;
        this.trades24h = 0;
        this.makerFee = 0;
        this.takerFee = 0;
        this.askPrice = 0;
        this.bidPrice = 0;
        this.date = new Date();
        if (!ticker) {
            return;
        }
        this.marketId = ticker.marketId || this.marketId;
        this.symbol = ticker.symbol || this.symbol;
        this.lastPrice = ticker.lastPrice || this.lastPrice;
        this.delta24h = ticker.delta24h || this.delta24h;
        this.high24h = ticker.high24h || this.high24h;
        this.low24h = ticker.low24h || this.low24h;
        this.volume24h = ticker.volume24h || this.volume24h;
        this.trades24h = ticker.trades24h || this.trades24h;
        this.makerFee = ticker.makerFee || this.makerFee;
        this.takerFee = ticker.takerFee || this.takerFee;
        this.askPrice = ticker.askPrice || this.askPrice;
        this.bidPrice = ticker.bidPrice || this.bidPrice;
        this.date = ticker.date || this.date;
    }
}
exports.Ticker = Ticker;
class Tickers {
    constructor() {
        this.list = {};
    }
}
exports.Tickers = Tickers;
//# sourceMappingURL=ticker.js.map